// One pop-up per visit. The add-to-home-screen guide and the notification prompt each ask for the
// visit's one slot before showing; the second to ask stays hidden until a later visit.
// (14 October 2026: both could appear on the same screen within half a second of each other.)

const KEY = 'cipher_prompt_this_visit';

export const claimPromptSlot = (name) => {
  try {
    const taken = sessionStorage.getItem(KEY);
    if (taken && taken !== name) return false;
    sessionStorage.setItem(KEY, name);
    return true;
  } catch {
    return true; // storage blocked: show it, as before this rule existed
  }
};

// Set when a client completes a workout day, so the notification prompt waits for their first one.
const FIRST_WORKOUT_KEY = 'cipher_first_workout_done';
export const WORKOUT_COMPLETED_EVENT = 'cipher:workout-completed';

export const markWorkoutCompleted = () => {
  try { localStorage.setItem(FIRST_WORKOUT_KEY, '1'); } catch { /* storage blocked */ }
  try { window.dispatchEvent(new Event(WORKOUT_COMPLETED_EVENT)); } catch { /* old browser */ }
};

export const hasCompletedAWorkout = () => {
  try { return !!localStorage.getItem(FIRST_WORKOUT_KEY); } catch { return false; }
};
